const ScmCdnInternalDynamicDomain = "";
export {
  ScmCdnInternalDynamicDomain
};

//# sourceMappingURL=scmCdnDomains.nonTTP.js.map